<template>
  <div>
    <test-card v-if="!loading" :testId="this.$route.params.testId"></test-card>
    <v-progress-circular
      v-else
      :v-model="loading"
      color="primary"
    ></v-progress-circular>
  </div>
</template>

<script>
import TestCard from "@/components/test/TestCard.vue";
import TestService from "@/services/TestService.js";
export default {
  components: {
    TestCard
  },
  data() {
    return {
      test: {},
      loading: true
    };
  },
  created() {
    this.getTest();
  },

  methods: {
    async getTest() {
      this.test = await TestService.getTest(this.$route.params.testId);
      this.loading = false;
    }
  }
};
</script>

<style scoped></style>
